import React, { useState } from 'react';
import { Box, FileInput, Text, Alert } from '@mantine/core';
import { IconAlertCircle, IconFileTypePdf } from '@tabler/icons-react';

const MAX_PDF_BYTES = 32 * 1024 * 1024; // 32 MB — Bedrock document content block cap

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || '');
      const commaIdx = result.indexOf(',');
      resolve(commaIdx >= 0 ? result.slice(commaIdx + 1) : result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function DiagramUploadStep({ pdfFile, onPdfChange }) {
  const [error, setError] = useState(null);

  const handle = async (file) => {
    setError(null);
    if (!file) {
      onPdfChange(null, '');
      return;
    }
    if (file.type !== 'application/pdf') {
      setError('PDF only — got ' + file.type);
      return;
    }
    if (file.size > MAX_PDF_BYTES) {
      setError(`File is ${(file.size / 1024 / 1024).toFixed(1)} MB — max is 32 MB`);
      return;
    }
    try {
      const base64 = await fileToBase64(file);
      onPdfChange(file, base64);
    } catch (err) {
      setError('Failed to read file: ' + err.message);
    }
  };

  return (
    <Box>
      <Text mb="sm" size="sm" c="dimmed">
        Drop the Lucid PDF here. Each page should be one bot — the entry router goes on page 1; downstream bots follow.
      </Text>
      <FileInput
        value={pdfFile}
        onChange={handle}
        accept="application/pdf"
        placeholder="Choose a PDF"
        leftSection={<IconFileTypePdf size={16} />}
        clearable
        size="md"
      />
      {error && (
        <Alert icon={<IconAlertCircle size={16} />} color="red" mt="md">
          {error}
        </Alert>
      )}
      {pdfFile && (
        <Text size="sm" c="dimmed" mt="sm">
          {pdfFile.name} — {(pdfFile.size / 1024).toFixed(0)} KB
        </Text>
      )}
    </Box>
  );
}

export default DiagramUploadStep;
